import { render, staticRenderFns } from "./MyPoint.vue?vue&type=template&id=40f46096&scoped=true"
import script from "./MyPoint.vue?vue&type=script&lang=js"
export * from "./MyPoint.vue?vue&type=script&lang=js"
import style0 from "./MyPoint.vue?vue&type=style&index=0&id=40f46096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f46096",
  null
  
)

export default component.exports